// converts a string into an url by adding either mailto: or http:// as
// a prefix if the string isn't a valid url
export const toUrl = (text: string) => {
  if (!text.startsWith('mailto:') && !text.startsWith('http')) {
    if (text.includes('@')) {
      text = `mailto:${text}`;
    } else {
      text = `http://${text}`;
    }
  }
  return text;
};
